import { defineComponent as J, ref as F, computed as L, createBlock as y, openBlock as C, withCtx as u, createElementVNode as r, createVNode as c, createElementBlock as U, createTextVNode as I, Fragment as G, renderList as H, unref as t, createCommentVNode as K, normalizeStyle as P, toDisplayString as Q } from "vue";
import { useModal as k, ScalarButton as w, ScalarIcon as X, ScalarModal as S } from "@scalar/components";
import { Draggable as Y } from "@scalar/draggable";
import { ScalarIconTrash as Z } from "@scalar/icons";
import ee from "../../components/Sidebar/Actions/DeleteSidebarListElement.vue.js";
import te from "../../components/Sidebar/Actions/EditSidebarListElement.vue.js";
import ne from "../../components/ViewLayout/ViewLayoutSection.vue.js";
import oe from "../Environment/EnvironmentColorModal.vue.js";
import le from "../Environment/EnvironmentModal.vue.js";
import se from "./components/EnvironmentForm.vue.js";
import { useActiveEntities as ae } from "../../store/active-entities.js";
import { useWorkspace as re } from "../../store/store.js";
const ie = { class: "flex h-full w-full flex-col gap-12 px-1.5 pt-8" }, ce = { class: "flex flex-col gap-4" }, de = { class: "rounded-lg border" }, ue = { class: "bg-b-2 flex cursor-grab items-center justify-between rounded-t-lg px-1 py-1 text-sm" }, ve = { class: "flex items-center" }, me = ["onClick"], fe = { class: "text-c-3 flex h-full items-center justify-center rounded-lg border p-4" }, Me = /* @__PURE__ */ J({
  __name: "CollectionEnvironment",
  setup(pe) {
    const { activeCollection: l, activeWorkspace: $, activeEnvVariables: D } = ae(), { collectionMutators: m } = re(), b = k(), h = k(), g = k(), _ = k(), M = F(""), s = F(null), E = F(void 0), V = L(() => {
      var n;
      return (n = l.value) != null && n["x-scalar-environments"] ? Object.entries(l.value["x-scalar-environments"]).map(
        ([e, i]) => ({
          uid: e,
          name: e,
          value: JSON.stringify(i.variables || {}),
          color: i.color || "#FFFFFF"
        })
      ) : [];
    }), N = () => {
      var n;
      !((n = l.value) != null && n.uid) || !s.value || (m.removeEnvironment(
        s.value,
        l.value.uid
      ), h.hide());
    }, j = (n) => {
      s.value = n, h.show();
    }, z = (n) => {
      var e;
      (e = l.value) != null && e.uid && (m.addEnvironment(
        n.name,
        {
          variables: {},
          color: n.color
        },
        l.value.uid
      ), g.hide());
    }, O = (n) => {
      s.value = n.name, M.value = n.color || "#FFFFFF", b.show();
    }, A = (n) => {
      var i, o, a;
      if (!((i = l.value) != null && i.uid) || !s.value)
        return;
      const e = {
        ...l.value["x-scalar-environments"],
        [s.value]: {
          variables: ((a = (o = l.value["x-scalar-environments"]) == null ? void 0 : o[s.value]) == null ? void 0 : a.variables) || {},
          color: n
        }
      };
      m.edit(
        l.value.uid,
        "x-scalar-environments",
        e
      ), b.hide();
    }, B = (n) => {
      s.value = n, E.value = n, _.show();
    }, W = () => {
      s.value = null, E.value = void 0, _.hide();
    }, R = (n) => {
      var p;
      if (!((p = l.value) != null && p.uid) || !s.value)
        return;
      const e = { ...l.value["x-scalar-environments"] };
      if (!e[s.value])
        return;
      const o = {}, a = Object.entries(e), f = a.findIndex(
        ([v]) => v === s.value
      );
      a.forEach(([v, x], d) => {
        d === f ? o[n] = x : o[v] = x;
      }), m.edit(
        l.value.uid,
        "x-scalar-environments",
        o
      ), s.value = null, E.value = void 0, _.hide();
    }, T = (n, e) => {
      var x;
      if (!((x = l.value) != null && x.uid))
        return;
      const i = { ...l.value["x-scalar-environments"] }, o = {}, a = Object.entries(i), f = a.findIndex(([d]) => d === n.id), p = a.findIndex(([d]) => d === e.id);
      if (f === -1 || p === -1)
        return;
      const v = a[f];
      v && (a.splice(f, 1), a.splice(p, 0, v), a.forEach(([d, q]) => {
        o[d] = q;
      }), m.edit(
        l.value.uid,
        "x-scalar-environments",
        o
      ));
    };
    return (n, e) => (C(), y(ne, null, {
      default: u(() => {
        var i;
        return [
          r("div", ie, [
            r("div", ce, [
              e[5] || (e[5] = r("div", { class: "flex items-start justify-between gap-2" }, [
                r("div", { class: "flex flex-col gap-2" }, [
                  r("div", { class: "flex h-8 items-center" }, [
                    r("h3", { class: "font-bold" }, "Environment Variables")
                  ]),
                  r("p", { class: "text-sm" }, [
                    I(" Set environment variables at your collection level. Use "),
                    r("code", { class: "font-code text-c-2" }, "{{ variable }}"),
                    I(" to add / search among the selected environment's variables in your request inputs. ")
                  ])
                ])
              ], -1)),
              (C(!0), U(G, null, H(V.value, (o) => (C(), y(t(Y), {
                key: o.name,
                id: o.name,
                isDraggable: !0,
                isDroppable: !0,
                parentIds: [],
                onOnDragEnd: T
              }, {
                default: u(() => [
                  r("div", de, [
                    r("div", ue, [
                      r("div", ve, [
                        c(t(w), {
                          class: "hover:bg-b-3 flex h-6 w-6 p-1",
                          onClick: (a) => O(o),
                          variant: "ghost"
                        }, {
                          default: u(() => [
                            r("span", {
                              style: P({ backgroundColor: o.color || "#FFFFFF" }),
                              class: "h-2.5 w-2.5 rounded-full"
                            }, null, 4)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        r("button", {
                          class: "hover:bg-b-3 rounded px-1 py-0.5 text-sm",
                          onClick: (a) => B(o.name)
                        }, Q(o.name), 9, me)
                      ]),
                      c(t(w), {
                        class: "hover:bg-b-3 hover:text-c-1 h-fit p-1.25",
                        variant: "ghost",
                        onClick: (a) => j(o.name)
                      }, {
                        default: u(() => [
                          c(t(Z), { class: "size-3.5" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    t(l) && t($) ? (C(), y(se, {
                      key: 0,
                      collection: t(l),
                      environment: o,
                      envVariables: t(D),
                      workspace: t($)
                    }, null, 8, ["collection", "environment", "envVariables", "workspace"])) : K("", !0)
                  ])
                ]),
                _: 2
              }, 1032, ["id"]))), 128)),
              r("div", fe, [
                c(t(w), {
                  class: "hover:bg-b-2 hover:text-c-1 flex items-center gap-2",
                  size: "sm",
                  variant: "ghost",
                  onClick: e[0] || (e[0] = (o) => t(g).show())
                }, {
                  default: u(() => [
                    c(t(X), {
                      class: "inline-flex",
                      icon: "Add",
                      size: "sm",
                      thickness: "1.5"
                    }),
                    e[4] || (e[4] = r("span", null, "Add Environment", -1))
                  ]),
                  _: 1,
                  __: [4]
                })
              ])
            ]),
            c(t(S), {
              size: "xxs",
              state: t(h),
              title: `Delete ${s.value || "Environment"}`
            }, {
              default: u(() => [
                c(ee, {
                  variableName: "Environment",
                  warningMessage: "Are you sure you want to delete this environment? This action cannot be undone.",
                  onClose: e[1] || (e[1] = (o) => t(h).hide()),
                  onDelete: N
                })
              ]),
              _: 1
            }, 8, ["state", "title"]),
            c(le, {
              activeWorkspaceCollections: t(l) ? [t(l)] : [],
              collectionId: (i = t(l)) == null ? void 0 : i.uid,
              state: t(g),
              onCancel: e[2] || (e[2] = (o) => t(g).hide()),
              onSubmit: z
            }, null, 8, ["activeWorkspaceCollections", "collectionId", "state"]),
            c(oe, {
              selectedColor: M.value,
              state: t(b),
              onCancel: e[3] || (e[3] = (o) => t(b).hide()),
              onSubmit: A
            }, null, 8, ["selectedColor", "state"]),
            c(t(S), {
              size: "xxs",
              state: t(_),
              title: `Edit ${s.value}`
            }, {
              default: u(() => [
                c(te, {
                  name: E.value ?? "",
                  onClose: W,
                  onEdit: R
                }, null, 8, ["name"])
              ]),
              _: 1
            }, 8, ["state", "title"])
          ])
        ];
      }),
      _: 1
    }));
  }
});
export {
  Me as default
};
